import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import { useSelector } from "react-redux";
import { getSkills } from "@icarius-pages/typesOfSkillsIndicators/selectors";
import { withStyles } from "@material-ui/core/styles";
import { getAppColor } from "@icarius-app/selectors";

const gridStyle = { padding: 10 };

const StyledDialog = withStyles({
  paper: {
    maxHeight: "95%",
  },
})(Dialog);

const ViewDialog = (props) => {

  const {
    open,
    data,
    handleClose,
    isPositionView,
  } = props;

  const skills = useSelector(getSkills);
  const color = useSelector(getAppColor);

  return (
    <StyledDialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {isPositionView ? getLocalizedString("viewWithIndicatorsPosition") : getLocalizedString("viewWithIndicators")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        <Grid container item xs={12}>
          <Grid container item direction="column" xs={12} justify="center" style={gridStyle}>
            <Typography variant="subtitle1" className="whiteText" style={{ marginTop: 16, marginBottom: 8, fontWeight: 'bold' }}>
              {getLocalizedString(isPositionView ? "position" : "specificCompetencyGroup")}: {data.group}
            </Typography>
            <List>
              {
                skills.length > 0 ? [...skills].sort((a, b) => (a.type === "Transversal" ? -1 : (b.type === "Transversal" ? 1 : 0))).map(skill => {
                  return (
                    <ListItem className="listItemBorderBottom" key={skill.key}>
                      <ListItemText
                        primary={<span style={{ color: color, fontWeight: 600, fontSize: "1.1rem" }}>{skill.type === "Específica" ? getLocalizedString("specificSkill") : getLocalizedString("transversalSkill")}</span>}
                        secondary={
                          <span className="whiteText" style={{ whiteSpace: 'pre-line', fontSize: "1rem" }}>
                            {getLocalizedString("name")}: <span style={{ textDecoration: "underline" }}>{skill?.value}</span>{"\n"}
                            {getLocalizedString("class")}: {skill?.class}{"\n"}
                            {getLocalizedString("targetSkillSpecific")}: {skill?.target}{"\n"}
                            {getLocalizedString("competencyOrigin")}: {getLocalizedString(data.group === skill.group || skill.type === "Transversal" ? "assignedToPosition" : "competencyAssignedToGroup")}
                          </span>
                        }
                      />
                    </ListItem>
                  )
                }) : (
                  <Typography variant="body1" className="whiteText" style={{ textAlign: 'center', marginTop: 16 }}>
                    {getLocalizedString(isPositionView ? "noCompetenciesForThisPosition" : "noCompetenciesForThisGroup")}
                  </Typography>
                )
              }
            </List>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction isAccept onClick={handleClose} text={getLocalizedString("close")} />
      </DialogActions>
    </StyledDialog >
  );
}

export default ViewDialog;